import { commonAccordionCustomStyles } from '../../Underwriting.styles';

export const accordionCustomStyles = {
  ...commonAccordionCustomStyles,

  '.MuiStack-root': {
    padding: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
};
